import { FC } from 'react'
import Swal from 'sweetalert2'
import {
  IconPaths,
  ModalSize,
  showAlert,
  showAlertLoading,
  showConfirmAlert,
} from '../../../../../../../_metronic/helpers'
import { RowActions, useModal, useToast } from '../../../../../../components'
import { ErrosVinculos } from '../../../components/ErrosVinculos'
import { EscalaFormModal } from '../../../components/EscalaFormModal'
import { EscalaList } from '../../../core/_models'
import { deleteEscalaEmpresa, getEscalaEmpresaById } from '../../../core/_requests'
import { extrairErrosValidacao } from '../../../core/escalaHelpers'
import { useQueryResponse } from '../../core/QueryResponseProvider'

type Props = {
  escala: EscalaList
  empresa: number
}

export const EscalaEmpresaActionsCell: FC<Props> = ({ escala, empresa }) => {
  const { showModal } = useModal()
  const { showToast } = useToast()
  const { refetch } = useQueryResponse()
  const nome = `escala iniciada em ${escala.dataInicioFormatada ?? escala.dataInicio}`

  /**
   * Não existe `PUT /escalas/empresa/{id}`: substituir é excluir + recriar, com
   * confirmação explícita (ver `EscalaFormModal`).
   */
  const abrirSubstituicao = async () => {
    try {
      showAlertLoading()
      const detalhe = await getEscalaEmpresaById(empresa, escala.id)
      Swal.close()
      showModal({
        title: 'Substituir escala',
        size: ModalSize.Large,
        content: (
          <EscalaFormModal
            eixo='empresa'
            empresa={empresa}
            escalaOriginal={detalhe}
            onSuccess={refetch}
          />
        ),
      })
    } catch (error) {
      Swal.close()
      const erros = extrairErrosValidacao(error)
      showModal({
        title: 'Não foi possível abrir a escala',
        size: ModalSize.Medium,
        content: (
          <ErrosVinculos
            titulo='A API recusou a consulta:'
            itens={erros.todas.length ? erros.todas : [erros.mensagem ?? 'Erro inesperado.']}
          />
        ),
      })
    }
  }

  const excluir = async () => {
    const confirmado = await showConfirmAlert({
      title: 'Excluir a escala?',
      text: 'Todos os dias gerados a partir dela serão removidos para esta instituição.',
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
      danger: true,
    })
    if (!confirmado) return

    try {
      showAlertLoading()
      await deleteEscalaEmpresa(empresa, escala.id)
      Swal.close()
      showToast({ variant: 'success', title: 'Escala removida.' })
      refetch()
    } catch (error) {
      const erros = extrairErrosValidacao(error)
      showAlert({
        title: 'Não foi possível excluir',
        text: erros.todas[0] ?? erros.mensagem ?? 'Erro inesperado.',
        icon: 'error',
      })
    }
  }

  return (
    <RowActions
      itemName={nome}
      primaryAction={{
        label: 'Substituir (excluir e recriar)',
        onClick: abrirSubstituicao,
        icon: IconPaths.Pen,
      }}
      items={[{ label: 'Excluir', onClick: excluir, danger: true }]}
    />
  )
}
